import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as bootstrap from 'react-bootstrap/dist/react-bootstrap';
import ForgetPassword from '../../components/authComponents/forgetPassword';
class ForgetPwdPage extends Component {
   
    render() {
      return (<>
        <div style={{height: "100%", padding: "50px 0"}} className="row row-table">
            <ForgetPassword />
   </div>
          </>
      )
    }
}
export default ForgetPwdPage;